export var OrderType;
(function (OrderType) {
    OrderType["SearchResults"] = "Results";
    OrderType["Checkout"] = "Checkout";
    OrderType["Checkin"] = "Checkin";
})(OrderType || (OrderType = {}));
